import React from 'react'
import { PageHeader } from '@shared/components/ui/page-header'
import { SubscriptionManagement } from '../components/SubscriptionManagement'

const SubscriptionsPage = () => {
  return (
    <div className="space-y-6">
      <PageHeader title="Subscriptions" description="Manage all platform subscriptions and billing" />
      <SubscriptionManagement />
    </div>
  )
}

export default SubscriptionsPage